export default "__VITE_ASSET__CEPbB8sm__"